import * as React from "react";
import { formMarkdownProcessorFactory } from "../../../../utils/markdown/processor";

const processor = formMarkdownProcessorFactory();

export const ApplyMarkdown: React.FC<{
  markdown: string;
}> = ({ markdown }) => {
  return (
    <div className={"markdown-preview-container"}>
      {(processor.processSync(markdown) as any).result}
    </div>
  );
};
